// assets
import { IconDashboard, IconUsersGroup, IconGrowth, IconHistory, IconBlockquote, IconFile, IconFileInvoice, IconMenuOrder, IconReceipt, IconReport, IconTruckDelivery, IconExchange, IconChartBar } from '@tabler/icons-react';

// constant
const icons = { IconUsersGroup, IconHistory, IconGrowth, IconDashboard, IconBlockquote, IconReport, IconMenuOrder, IconTruckDelivery, IconReceipt, IconFileInvoice, IconFile, IconExchange, IconChartBar };

// ==============================|| DASHBOARD MENU ITEMS ||============================== //

const procurementDashboardMenu = {
    id: 'dashboard',
    title: 'Dashboard',
    type: 'group',
    roles: ['super_admin', 'system_admin', 'department_head'],
    permissions: ['dashboard.read'],
    children: [
        {
            id: 'default',
            title: 'Dashboard',
            type: 'item',
            url: '/procurement/dashboard',
            icon: icons.IconDashboard,
            breadcrumbs: false
        },
        {
            id: 'requisitions',
            title: 'Requisitions Management',
            type: 'item',
            url: '/procurement/requisitions',
            icon: icons.IconReceipt,
            breadcrumbs: true,
            permissions: ['requisitions.read']
        },
        {
            id: 'rfq',
            title: 'RFQ Management',
            type: 'item',
            url: '/procurement/rfqs',
            icon: icons.IconBlockquote,
            breadcrumbs: true,
            permissions: ['rfqs.read']
        },
        {
            id: 'orderbook',
            title: 'Order Book Management',
            type: 'item',
            url: '/procurement/orderbook',
            icon: icons.IconMenuOrder,
            breadcrumbs: true,
            permissions: ['purchases_order.read']
        },
        {
            id: 'delivery',
            title: 'Delivery Notes Management',
            type: 'item',
            url: '/procurement/delivery',
            icon: icons.IconTruckDelivery,
            breadcrumbs: true,
            permissions: ['delivery_notes.read']
        },
        {
            id: 'invoices',
            title: 'Invoice Management',
            type: 'item',
            url: '/procurement/invoices',
            icon: icons.IconFileInvoice,
            breadcrumbs: false,
            permissions: ['invoices.read']
        },
        {
            id: 'certificates',
            title: 'Certificate Management',
            type: 'item',
            url: '/procurement/certificates',
            icon: icons.IconFile,
            breadcrumbs: false,
            permissions: ['certificates.read']
        },
        {
            id: 'reports',
            title: 'Analytics Reports',
            type: 'item',
            url: '/procurement/analytics',
            icon: icons.IconChartBar,
            breadcrumbs: true, roles: ['department_head', 'system_admin', 'super_admin'],
            permissions: ['dashboard.read']
        },
        {
            id: 'performance',
            title: 'Team Performance',
            type: 'item',
            url: '/procurement/team',
            target: false,
            icon: icons.IconUsersGroup,
            roles: ['department_head', 'system_admin', 'super_admin'],
            permissions: ['dashboard.read']
        },
        {
            id: 'audit',
            title: 'Audit Logs',
            type: 'item',
            icon: icons.IconHistory,
            url: '/procurement/audit-logs',
            target: false,
            roles: ['department_head', 'system_admin', 'super_admin'],
            permissions: ['audit_logs.read']
        }
    ]
};

export default procurementDashboardMenu;
